import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/close-button.svg'


const _withScopeId = n => (_pushScopeId("data-v-c718f52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close-button"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal__close-button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
      }, _hoisted_4),
      _createElementVNode("iframe", {
        class: "modal__iframe",
        src: $props.videoLink,
        frameborder: "0",
        allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture",
        allowfullscreen: ""
      }, null, 8, _hoisted_5)
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}